/**
 * Global Imports
*/

import PropTypes from 'prop-types';
import React, { useEffect, useContext, useState } from 'react';
import { Link } from 'react-router-dom';

/**
 * Root Imports
*/

import { CssClassName } from '~/util/Css';

/**
 * Local Imports
*/



/**
 * Locals
*/

/**
 * Exports
*/

/**
 * 
 */
export function TableHead(props) {
  return (
    <th className='p-3 font-bold uppercase text-gray-600 hidden lg:table-cell'>
      { props.children }
    </th>
  );
}

/**
 * 
 */
export function TableBodyRow(props) {
  /** Output **/

  return (
    <tr className='bg-white lg:hover:bg-gray-100 flex lg:table-row flex-row lg:flex-row flex-wrap lg:flex-no-wrap mb-10 lg:mb-0'>
      { props.children }
    </tr>
  );
}

/**
 * 
 */
export function TableBodyData(props) {
  return (
    <td className='w-full lg:w-auto p-3 text-gray-800 text-center block lg:table-cell relative lg:static'>
      { props.children }
    </td>
  );
}

/**
 * 
 */
export function TableBodyLink(props) {
  return (
    <td className='w-full lg:w-auto lg:table-cell relative lg:static'>
      <Link to={ props.to } className='p-4 text-gray-800 text-center block'>
        { props.children }
      </Link>
    </td>
  );
}

/**
 * 
 */
export function Table(props) {
  /** Renderers **/
  
  /**
   * 
   */
  const renderHeader = () => (
    <thead>
      <tr>
        {
          props.thead.map((th, index) => (
            <TableHead key={ index }>{ th }</TableHead>
          ))
        }
      </tr>
    </thead>
  );
  
  /** Output **/
  
  return (
    <table className='w-full bg-gray-300 shadow'>
      { renderHeader() }
      <tbody>
        { props.children }
      </tbody>
    </table>
  );
}